import React, { useEffect, useState } from "react";
import { voiceBus } from "../voice/voiceBus";

export default function NowPlayingBar() {
    const [st, setSt] = useState(voiceBus.get());
    useEffect(() => voiceBus.subscribe(setSt), []);
    if (!st.src) return null;

    const fmt = (t = 0) => `${String(Math.floor(t / 60)).padStart(2, '0')}:${String(Math.floor(t % 60)).padStart(2, '0')}`;

    const seek = (e) => {
        const bar = e.currentTarget.getBoundingClientRect();
        const x = Math.max(0, Math.min(e.clientX - bar.left, bar.width));
        const ratio = x / bar.width;
        const t = (st.duration || 0) * ratio;
        voiceBus.emit({ position: t }); // сам плеер подхватит
    };

    return (
        <div className="nowPlay">
            <div className="nowPlay__left">
                <button
                    className="nowPlay__btn"
                    onClick={() => voiceBus.emit({ playing: !st.playing })}
                    title={st.playing ? "Пауза" : "Воспроизвести"}
                >
                    {st.playing ? "⏸" : "▶️"}
                </button>
                <div className="nowPlay__meta">
                    <div className="nowPlay__name" title={st.name || st.src}>{st.name || st.src}</div>
                    <div className="nowPlay__time">{fmt(st.position)} / {fmt(st.duration)}</div>
                </div>
            </div>
            <div className="nowPlay__bar" onClick={seek}>
                <div
                    className="nowPlay__bar-fill"
                    style={{ width: st.duration ? `${(st.position / st.duration) * 100}%` : 0 }}
                />
            </div>
        </div>
    );
}
